import {LIMIT_PAGE_DEFAULT} from "@/shared/constant";
import moment from "moment";

export class ManageCodParams {
    page = 1;
    limit = LIMIT_PAGE_DEFAULT;
    status?: number;
    fromDate? = moment().startOf('month').valueOf();
    toDate? = moment().endOf('month').valueOf();
}
